/* This example requires Tailwind CSS v2.0+ */
import { Primary } from "../buttons/Primary";
import { Fifth } from "../buttons/Fifth";

const features = [
  {
    description:
      "Debes tener 18 años o más para poder realizar una solicitud y tener tus documentos al día.",
  },
  {
    description:
      "Para poder solicitar un crédito en Galilea debes ser residente en Colombia y ser colombiano/a.",
  },
  {
    description: "Debes tener una cuenta bancaria activa o Nequi a tu nombre.",
  },
  {
    description:
      "Tener un número de celular y correo electrónico propios, el cuál verificaremos por tu seguridad.",
  },
];

export function Requisitos() {
  return (
    <section
      className="overflow-hidden bg-purpleLight font-walsheim text-tdark"
      aria-labelledby="requisitos-heading"
    >
      <div className="max-w-7xl mx-auto py-20 px-6 lg:px-8 pt-28">
        <div className="lg:flex">
          <div className="relative block lg:w-1/2">
            <div className="lg:absolute lg:w-120 h-auto lg:top-1/2 lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:-translate-y-1/2">
              <img
                className="w-110 h-auto"
                src="/png/registro.png"
                alt="Crear-cuenta"
              />
            </div>
          </div>
          <div className="lg:w-1/2 lg:pl-20">
            <div>
              <h2
                id="requisitos-heading"
                className="pt-8 lg:pt-0 text-4xl font-bold tracking-tight sm:text-5xl lg:pr-20"
              >
                Requisitos básicos para solicitar un crédito
              </h2>
            </div>
            <dl className="my-10 space-y-10">
              <ul className="space-y-4 marker:text-tdark list-disc text-lg">
                {features.map((feature, idx) => (
                  <li key={idx} className="ml-4 mt-2 text-lg">
                    {feature.description}
                  </li>
                ))}
              </ul>
              <div className="pt-4">
                <div className="lg:flex">
                  <div className="block lg:w-1/2 py-2">
                    <div className="w-52 pb-10 md:mx-0 mx-auto"><Primary href="/registrarse" text="Aplicar ahora" aria-label="Aplicar ahora al crédito Galilea" /></div>
                  </div>
                  <div className="pl-2 block lg:w-1/2 py-2">
                    <a href="/tarifas" className="w-52 pb-10 md:mx-0 mx-auto">
                      <Fifth text="Tasas y tarifas" />
                    </a>
                  </div>
                </div>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
